export const USE_PLACES_ADDRESS = process.env.REACT_APP_USE_PLACES_ADDRESS === String(true);
